// @ts-check
import Text from './base/Text';
import { Flex } from './base/layout-components';
import * as TrackingService from 'common/services/tracking.service';
import {
  PRIVACY_POLICY_LINK,
  TERMS_LINK,
  TRACKING
} from 'common/constants/constants';
import React from 'react';
import { LBButton } from '@linearb/buzz';

const TermsAndPolicy = ({
  page = null,
  page_tab = null,
  separator = (
    <Text color='chambray' pl='0.2rem' pr='0.2rem'>
      and
    </Text>
  ),
  inline = false
}) => {
  const trackingVars = {
    ...(page ? { page } : {}),
    ...(page_tab ? { page_tab } : {})
  };
  const Wrapper = inline ? React.Fragment : Flex;

  return (
    <Wrapper items='center'>
      <LBButton asChild variant='link'>
        <a
          href={TERMS_LINK}
          target='__blank'
          onClick={() => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              ...trackingVars,
              click_type: TRACKING.CLICK.TERMS
            });
          }}
        >
          Terms of Service
        </a>
      </LBButton>
      {separator}
      <LBButton asChild variant='link'>
        <a
          href={PRIVACY_POLICY_LINK}
          target='__blank'
          onClick={() => {
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              ...trackingVars,
              click_type: TRACKING.CLICK.POLICY
            });
          }}
        >
          Privacy Policy
        </a>
      </LBButton>
    </Wrapper>
  );
};
export default TermsAndPolicy;
